import Permissions from '@/ecm/models/Permissions';
import Field from '@/ecm/models/document/Field';
import store from '@/store';

export default class SearchResultItem {
    constructor(dto) {
        this.id = -1;
        this.contentTypeID = 0;
        this.totalComments = 0;
        this.totalAttachments = 0;
        this.totalAlerts = 0;
        this.title = '';
        this.value = '';
        this.contentType = '';
        this.version = '';
        this.author = '';
        this.distributor = '';
        this.extension = '';
        this.isLastVersion = false;
        this.isDigitallySigned = false;
        this.isDistributed = false;
        this.isPendingConfirmation = false;
        this.isBlocked = false;
        this.lockInfo = '';
        this.canUnblock = false;
        this.isDeleted = false;
        this.isInWorkflow = false;
        this.permissions = [];
        this.groups = [];
        this.fields = [];
        this.hasPlugins = false;
        this.totalLinkedDocuments = 0;
        this.documentDeferredProcessType = 0;
        this.currentUserHasValidatedDocument = false;
        this.totalFlowValidations = 0;

        if (dto) {
            this.id = dto.ObjectID;
            this.contentTypeID = dto.ContentTypeID;
            this.title = dto.Title;
            this.contentType = dto.ContentType;
            this.isLastVersion = dto.IsLastVersion;
            this.isInWorkflow = dto.IsInWorkflow;
            this.isDigitallySigned = dto.IsDigitallySigned;
            this.isDistributed = dto.IsDistributed;
            this.isPendingConfirmation = dto.IsPendingConfirmation;
            this.version = dto.Version;
            this.author = dto.Author;
            this.distributor = dto.Distributor;
            this.extension = dto.Extension;
            this.totalComments = dto.TotalComments;
            this.value = dto.Value;
            this.totalAlerts = dto.TotalAlerts;
            this.totalAttachments = dto.TotalAttachments;
            this.totalFlowValidations = dto.TotalFlowValidations;
            this.currentUserHasValidatedDocument = dto.CurrentUserHasValidatedDocument;
            this.permissions = new Permissions(dto.Permissions, dto.ObjectLock);
            this.fields = dto.Fields.map(function (dto) { return new Field(dto); });
            this.hasPlugins = dto.HasPlugins;
            if (dto.ObjectLock) {
                this.isBlocked = true;
                this.lockInfo = dto.ObjectLock.LockInfo;
                if (dto.ObjectLock.UserID == store.getters['account/user'].Id) {
                    this.canUnblock = true;
                }
                this.documentDeferredProcessType = dto.ObjectLock.DocumentDeferredProcessType;
            }
            this.isDeleted = dto.IsDeleted;
            this.totalLinkedDocuments = dto.TotalLinkedDocuments;
        }
    }
}
